import Pricing from "./Pricing";
import PricingCTA from "./PricingCTA";
import FAQ from "./FAQ";

/**
 * Wrapper for Pricing and FAQ sections.
 * The old unified gradient and glow orbs have been removed to support the new distinct section backgrounds.
 */
export default function PricingFaqShadedGroup() {
  return (
    <div className="relative clip-x-visible-y w-full">
      <Pricing />
      <PricingCTA />
      <FAQ />
    </div>
  );
}
